import ApplicationUploadDocuments from './ApplicationUploadDocuments.component';

export default ApplicationUploadDocuments;